<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
let yValue = [[8, 10, 16, 19, 20], [11, 12, 18, 20, 22],[19, 16, 18, 30, 35]];
// let xValue = ["安全帽", "绝缘杆", "验电杆", "绝缘手套", "绝缘靴"] ;
let names = ['强筋', "中筋","弱筋"];
let xValue = ["2019", "2020", "2021", "2022", "2023"];
let colorList = [
  {color:"rgba(30, 149, 236, 1)",borderColor:'rgba(30, 149, 236, 1)'},
  {color:"rgba(226, 174, 45,1)",borderColor:'rgba(226, 174, 45, 1)'},
  {color:"rgba(34, 249, 98, 1)",borderColor:'rgba(34, 249, 98, 1)'}
];
let series = [];
// let offset=[[(-7), -10],[7, -10]];
let xoffset = (names.length-1)*(-7);
names.forEach((item, index) => {
  // series.push(
  //   {
  //     name: item,
  //     type: "pictorialBar",
  //     symbol: "rect",
  //     symbolSize: [12, 5],
  //     symbolPosition: "end",
  //     // symbolOffset: offset[index],
  //     symbolOffset:[(xoffset)+(index*14), -10],
  //     // z: 2,
  //     // label: {
  //     //   show: true,
  //     //   position: "top",
  //     //   textStyle: {
  //     //     color: "#969a9d",
  //     //   },
  //     // },
  //     tooltip: {
  //       show: false,
  //     },
  //     itemStyle: {
  //       normal: {
  //         color: colorList[index].borderColor ,
  //       },
  //     },
  //     data: yValue[index],
  //   }
  // )
  series.push(
    {
      name: item,
      type: "bar",
      barWidth: 12,
      z: 1,
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: colorList[index].color ,
            },
            {
              offset: 0.5,
              color: colorList[index].color ,
            },
            {
              offset: 1,
              color: "transparent",
            },
          ]),
          borderColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: colorList[index].borderColor  ,
            },
            {
              offset: 0.5,
              color: colorList[index].borderColor  ,
            },
            {
              offset: 1,
              color: "transparent",
            },
          ]),
        },
      },
      data: yValue[index],
    }
  )
})

// 创建ECharts配置对象
const option = {
  title: {
    text: "单位(万吨)",
    textStyle: {
      fontSize: 18,
      fontWeight: "normal",
      color: "#fff", //标题颜色
    },
    top: "5%",
    left: "5%",
  },
  tooltip: {
    trigger: "axis",
  },
  grid: {
    top: "20%",
    left: "5%",
    right: "10px",
    bottom: "30px",
    containLabel: true,
  },
  legend: {
    show: true,
    icon: "roundRect",
    orient: "horizontal",
    itemWidth: 20,
    itemHeight: 15,
    textStyle: {
      fontSize: 14, //字体大小
      color: "#b9c8d4", //字体颜色
    },
    top: "5%",
    right: "3%", //距离右侧
    data: names,
  },
  calculable: true,
  animation: true,

  xAxis: [
    {
      type: "category",
      triggerEvent: true,  //记住要加上 设置为true后，可触发事件

      axisLabel: {
        interval: 0, // 解决x轴名称过长问题
        textStyle: {
          color: "#c8d8e3",
          fontSize: 16,
        },
        formatter: (value, index) => {
          if (value.length > 6) {
            return value.substring(0, 4) + '...'
          }
          return value
        },
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
      },
      data: xValue,
    },
  ],
  yAxis: [
    {
      type: "value",
      nameGap: 8,
      nameTextStyle: {
        color: "#d1d1d1",

      },

      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        symbol: ["none", "arrow"],
        symbolSize: [5, 10],
        lineStyle: {
          color: "#b2e7ff",

          opacity: 0.3,
        },
      },
      splitLine: {
        //保留网格线
        show: true,
        lineStyle: {
          //y轴网格线设置
          color: "#032e42",
          width: 1,
        },
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#d1d1d1", //字体颜色
          fontSize: 16,
        },
      },
    },
  ],
  series: series,
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
